// `(markdown …)` tile op.
//
// `(markdown :span [W H] :content "…markdown source…")`
//
// A free-text tile: no data refs and no sub-forms. `:content` is the raw
// GitHub-flavored Markdown string, rendered by the shared MarkdownRenderer.
// Registered in `dashboardMeta` (NOT `opMeta`) — only reachable as a child
// of `(dashboard …)`.

import { z } from 'zod';

import { spanArg } from '../args.ts';
import { buildSpec, type DashboardCtx, dashboardMeta } from '../dispatch.ts';
import type { MarkdownSpec } from '../value.ts';

export const markdown = z
  .object({
    name: z.literal('markdown'),
    params: z.tuple([]),
    span: spanArg,
    content: z.string().min(1),
  })
  .describe('A free-text tile rendering GitHub-flavored Markdown. `:content` is the markdown source string.')
  .register(dashboardMeta, {
    evaluation: 'special',
    effect: 'pure',
    example: { expr: '(markdown :span [12 2] :content "## Notes\\n- first point\\n- second point")' },
    apply: (data, ctx: DashboardCtx): Promise<MarkdownSpec> =>
      buildSpec('markdown-spec', data, ctx, [
        { key: 'span', mode: 'copy' },
        { key: 'content', mode: 'copy' },
      ]),
  });
